import React, { useEffect } from "react";
import "./home.css";
import { Helmet } from "react-helmet";
import Loading from "../../base/loading/loading";
import TopMenu from "../../base/topMenu/topMenu";
import Header from "../../base/header/header";
import Carousel from "../../base/carousel/carousel"
import Cta from "../../base/cta/cta";
import TwoColumns from "../../base/twoColumns/twoColumns";
import Footer from "../../base/footer/footer";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {renderOptions, justURLString, getPageData, validatePath} from "../../../utils/generals"
import { Link, useLocation } from "react-router-dom";


let query = `
{
    homePageCollection  (where: {seoMetadata: {path:"&slug&"}}){
      items{
        pageTitle
        slug
        urlAccount
        seoMetadata{
            description
            hreflang
            href
            keywords
            canonicalHref
        }
        nav{
          logo{
            url
          }
          menuItems
        }
        carouselCollection{
          items{
            title
            description
            url
          }
        }
        headerOne
        servicesTiles
        cta {
          icon{
            url
          }
          text
          labelButton
          ctaButton
        }
        headerTwo
        twoColumns
        faqs {
          json
        }
        legals {
          title
          textContent {
            json
          }
        }
        footer{
          text
          socialMedia
        }
        downloadAppButtonsHome{
          title
          downloadButtons
        }
      }
    }
  }
`;

const Home = () => {

  const [page, setPage] = React.useState(null);
  const location = useLocation();
  const [slug, setSlug] = React.useState(null);



  useEffect(() => {
    // const aURI = String(location.pathname).charAt(location.pathname.length -1);
    // let uri = location.pathname;
    // if (aURI === "/") {
    //   uri = uri.slice(0,-1);
    // }

    query = query.replace("&slug&", validatePath(location.pathname));
   
    const pageData = getPageData(query);

    const codeCountry = String(location.pathname).split("/");
    setSlug(codeCountry[1]);

    pageData
      .then((res) => {
        res.homePageCollection.items[0].cta.currentURL =
          justURLString();
        setPage(res.homePageCollection.items[0]);
      })
      .catch((errors) => {
        console.log(errors);
      });
  }, [location.pathname]);

  // show a loading screen case the data hasn't arrived yet
  if (!page) {
    return(<Loading />)
  }

  return (
    <div className="container-fluid main-container">        
      <TopMenu  urlAccount={page.urlAccount}   />
      <Helmet htmlAttributes={{ lang : page.seoMetadata.hreflang }}>
        <meta charSet="utf-8" />
        <title>{page.pageTitle}</title>
        <meta name="description" content={page.seoMetadata.description}></meta>
        <meta name="keywords" content={page.seoMetadata.keywords}></meta>
        <link
          rel="alternate"
          hrefLang={page.seoMetadata.hreflang}
          href={page.seoMetadata.href}
          key={page.seoMetadata.hreflang}
        />
        <link rel="alternate" href="https://qa.tigomoney.com" hreflang="x-default" />

        <link rel="canonical" href={page.canonicalHref} />
      </Helmet>
      <Header logo={page.nav.logo} menuItems={page.nav.menuItems.menu} />
      {/* <section
        className="carousel-container "
        style={{ backgroundImage: `url(${page.carousel.url})` }}
      ></section> */}
      <section>
        <Carousel data={page.carouselCollection}/>
      </section>

      <section className="services-container ">
        <h1>{page.headerOne}</h1>
        <div className="container  tiles-container d-flex align-items-center justify-content-center ">
          <div className="row  ">
            {page.servicesTiles.items.map((service, index) => {
              return (
                <div key={index} className="col p-1 service-item ">
                  <div className="d-flex justify-content-center">
                    <img src={service.icon_url} alt={service.title} />
                  </div>
                  <div className="w-100 pt-3  d-flex justify-content-center title-service-container">
                    <div className="title-button">{service.title}</div>
                  </div>
                  <div className=" col-12  services-btn-container d-flex justify-content-center">
                    <a href={service.button_url} target="_blank" rel="noreferrer">
                    <button className="service-button">
                      {/* <Link to={service.button_url} target="_blank"> */}
                        {service.button_label}
                      {/* </Link> */}
                    </button>
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <Cta data={page.cta} />
        <br /><br /><br />
      </section>
      
      <section className="mt-4">
        <TwoColumns data={page.twoColumns}/>
      </section>

      <section>
        <div className="container-fluid faqs-container  pt-4">
            <div className="container faqs-div mt-4 pt-2">
              {documentToReactComponents(page.faqs.json, renderOptions)}
            </div>
        </div>
      </section>
      
      <Footer  data={page.footer}/>
      <div className=" p-1 container-fluid  tyc-container d-flex justify-content-center">
          
          {slug === 'home-py' ? 
                     
          <a href={"/legales/terminos-condiciones-py.html"}>
            Términos y Condiciones
            </a>
            
          : 

            <Link to={"/legales?id=homePageCollection&slug=home-"+slug}>
            Términos y Condiciones
            </Link>
          }
          
          
      </div>
      
    </div>
  );
};
export default Home;
